<template>
  <Container v-if="years.length">
    <Title>Years</Title>
    <ParentSize @resize="setSize">
      <ChartSvg :width="parentWidth" :height="parentHeight" v-yearSlider:props="props" />
    </ParentSize>
    <SliderNote v-if="showNote">Note - Years represent beginnings of academic year date ranges</SliderNote>
  </Container>
</template>

<script>
import { pipe, map, prop, uniq, reject, isNil, sort } from 'ramda';

import { Container, Title, SliderNote } from './yearSlider.styles';
import { yearSlider } from './yearSlider.directives';
import { ParentSize, ParentSizeMixin } from '../responsive';
import { ChartSvg } from '../charts/base';
import { mapGetters, mapMutations } from 'vuex';
import { PREFIX as REGIONS_STORE } from '../../../modules/regions';
import { SET_YEAR_FILTER } from '@/modules/regions/regions.mutations';
import { EDUCATIONAL_EXCHANGE, YEAR_FIELD } from '../../constants';
import { GET_SELECTED_TOPIC } from '@/modules/regions/regions.getters';

export default {
  mixins: [ParentSizeMixin],
  components: { Container, Title, ParentSize, ChartSvg, SliderNote },
  props: {
    data: Array,
  },
  data() {
    return {
      years: [],
    };
  },
  methods: {
    ...mapMutations(REGIONS_STORE, [SET_YEAR_FILTER]),
    handleChange(year) {
      this[SET_YEAR_FILTER](year);
    },
  },
  created() {
    const diff = (a, b) => a - b;
    this.years = pipe(map(prop(YEAR_FIELD)), uniq, reject(isNil), sort(diff))(this.data);

    this[SET_YEAR_FILTER](this.years[this.years.length - 1]);
  },
  computed: {
    ...mapGetters(REGIONS_STORE, [GET_SELECTED_TOPIC]),

    showNote() {
      return this[GET_SELECTED_TOPIC] === EDUCATIONAL_EXCHANGE;
    },
    props() {
      return {
        options: this.years,
        handleChange: this.handleChange,
        width: this.parentWidth,
      };
    },
  },
  directives: { yearSlider },
};
</script>
